<template>
    <h2 class="pp-lottery-winnings__title">{{ addonDisplayName }}</h2>
    <DsTable>
        <DsRow>
            <DsCell type="th">Pořadí</DsCell>
            <DsCell v-if="showGuessedColumn" type="th">Uhodnuto</DsCell>
            <DsCell type="th">Výhra</DsCell>
        </DsRow>
        <DsRow v-for="(res, index) in winnings" :key="index">
            <DsCell>{{ index + 1 }}. pořadí</DsCell>
            <DsCell v-if="showGuessedColumn">{{ guessedText[index] }}</DsCell>
            <DsCell>
                <template v-if="res.amount && res.wins">
                    <strong v-html="StringUtils.formatCurrency(res.amount)"></strong>
                    <span v-html="' ' + formatNumberOfWinners(res.wins)"></span
                ></template>
                <template v-else>–––</template>
            </DsCell>
        </DsRow>
    </DsTable>
</template>
<script lang="ts" setup>
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { LotteryDrawWinning } from "@/lotteries/services/model/lottery-draw-winning";

const props = defineProps<{
    lottery: Lottery;
    winnings: LotteryDrawWinning[];
}>();

const addonDisplayName = LotteryParser.addonDisplayName(props.lottery);
const showGuessedColumn = props.lottery === Lottery.sportka || props.lottery === Lottery.eurojackpot;

const guessedText = [
    "Celé šestičíslí",
    "Koncové pětičíslí",
    "Koncové čtyřčíslí",
    "Koncové trojčíslí",
    "Koncové dvojčíslí",
    "Koncové číslo",
    "Koncové číslo +/- 1",
];

const formatNumberOfWinners = (winners: number) => {
    const formattedWinners = StringUtils.formatNumber(winners);
    return props.lottery === Lottery.euromiliony ? `/ ${formattedWinners}x` : `(${formattedWinners}x)`;
};
</script>
